<div class="audit-details-container">
  <div class="flex flex-row justify-between pb-10">
    <div class="flex flex-col">
      <div class="mat-headline-5 mb-8 fw-700">{{ auditData?.action }}</div>
      <div class="mat-body fw-500 fs-16 flex items-center">
        <img class="icon-lg mr-8" src="assets/images/bank.png" alt="bank">
        {{ auditData?.tenantId }}
      </div>
    </div>
    <mat-icon svgIcon="close" class="close-icon" (click)="closeSidenav()"></mat-icon>
  </div>
  <mat-divider class="mb-18 neutral-2"></mat-divider>
  <mat-tab-group animationDuration="0ms">
    <mat-tab label="{{'AUDIT_LIST.SUMMARY' | transloco}}">
      <div class="flex flex-row">
        <div class="metrics pt-8 pb-8">
          <div class="overview-values fw-700">{{'AUDIT_LIST.ACTION_LOG' | transloco}}</div>
          <div>{{auditData?.action ? auditData?.action:'--'}}</div>
        </div>
        <div>
          <div class="metrics pt-8 pb-8">
            <div class="overview-values fw-700">{{ 'AUDIT_LIST.STATUS_LOG' | transloco }}</div>
            <div class="flex inline-flex justify-center items-center status fw-500" [ngClass]="auditData?.status">
              <mat-icon *ngIf="auditData.status !== '-'" [svgIcon]="auditData?.status === 'Success' ? 'check_circle' : 'cancel'"
                class="icon-md p-1 mr-2" [ngClass]="auditData?.status">
              </mat-icon>
              <span [ngClass]="auditData?.status">
                {{ auditData?.status ? auditData?.status : '--' }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <mat-divider class="mb-20 mt-20 neutral-2 mat-divider-dashed"></mat-divider>
      <div class="flex flex-row">
        <div class="metrics pt-8 pb-8">
          <div class="overview-values fw-700">{{'AUDIT_LIST.TIME_STAMP_LOG' | transloco}}</div>
          <div> {{ auditData.timestamp ? (auditData.timestamp | date:'dd MMM yyyy HH:mm:ss') : '-' }}</div>
        </div>
        <div>
          <div class="overview-values fw-700">{{'AUDIT_LIST.RESPONSE_CODE_LOG' | transloco}}</div>
          <div>
            <span [ngClass]="[getResponseText(auditData?.responseCode).class, 'fw-500']">
               {{ auditData?.responseCode }} {{ getResponseText(auditData?.responseCode).text }}
            </span>
          </div>
        </div>
      </div>
      <mat-divider class="mb-20 mt-20 neutral-2 mat-divider-dashed"></mat-divider>
      <div class="flex flex-row">
        <div class="metrics pt-8 pb-8">
          <div class="overview-values fw-700">{{'AUDIT_LIST.HTTP_METHOD_LOG' | transloco}}</div>
          <div>
            <span [ngClass]="[getHttpMethodClass(auditData?.httpMethod), 'fw-500']">
            {{auditData?.httpMethod ? auditData?.httpMethod:'--'}}
            </span>
          </div>
        </div>
        <div>
          <div class="overview-values fw-700">{{'AUDIT_LIST.INITIATED_BY_LOG' | transloco}}</div>
          <div>{{auditData?.userEmail ? auditData?.userEmail:'--'}}</div>
        </div>
      </div>
      <mat-divider class="mb-20 mt-20 neutral-2 mat-divider-dashed"></mat-divider>
      <div class="flex flex-row">
        <div class="metrics pt-8 pb-8">
          <div class="overview-values fw-700">{{'AUDIT_LIST.REQUEST_URL_LOG' | transloco}}</div>
          <div>{{auditData?.requestUri ? auditData?.requestUri:'--'}}</div>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="{{'AUDIT_LIST.REQUEST_BODY' | transloco}}">
      <div *ngIf="auditData?.requestBody" class="cob-dialog-wrapper hover-container">
        <div class="flex flex-col">
          <div class="flex flex-row w-100-percent json-line-wrapper pl-6">
            <div class="json-data flex flex-col">
              <div class="json-line" *ngFor="let line of formattedReqBody; let i = index">
                <span class="line-number">{{ i + 1 }}.</span>
                <span class="line-content">{{ line }}</span>
              </div>
            </div>
            <div>
              <button [ngClass]="[copyReq ? 'copied': 'copy']"
                class=" copy-btn mr-8 mt-8 flex justify-end h-30 pt-4 pr-8 pb-4 pl-8" (click)="copyReqText()">
                <span *ngIf="!copyReq" class="fs-16 fw-500 item flex items-center">
                  <mat-icon class="h-18 w-18 mr-6" svgIcon="content_copy"></mat-icon>{{ 'ERROR_DIALOG.COPY' | transloco
                  }}
                </span>
                <span *ngIf="copyReq" class="fs-16 fw-500 item flex items-center copied-text">
                  <mat-icon class="h-18 w-18 mr-6" svgIcon="check"></mat-icon>{{ 'ERROR_DIALOG.COPIED' | transloco }}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!auditData?.requestBody" class="empty-data flex flex-col items-center mt-32">
        <img class="w-106" alt="request body not found" src="/assets/images/request_body_not_available.png">
        <div class="flex mt-6 ">{{'AUDIT_LIST.NO_REQ_BODY' | transloco }}</div>
      </div>
    </mat-tab>
    <mat-tab label="{{'AUDIT_LIST.RESPONSE_BODY' | transloco}}">
      <div *ngIf="auditData?.responseBody" class="cob-dialog-wrapper hover-container">
        <div class="flex flex-col">
          <div class="flex flex-row w-100-percent json-line-wrapper pl-6">
            <div class="json-data flex flex-col">
              <div class="json-line" *ngFor="let line of formattedResBody; let i = index">
                <span class="line-number">{{ i + 1 }}.</span>
                <span class="line-content">{{ line }}</span>
              </div>
            </div>
            <div>
              <button [ngClass]="[copyRes ? 'copied': 'copy']"
                class="copy-btn mr-8 mt-8 flex justify-end h-30 pt-4 pr-8 pb-4 pl-8" (click)="copyResText()">
                <span *ngIf="!copyRes" class="fs-16 fw-500 item flex items-center">
                  <mat-icon class="h-18 w-18 mr-6" svgIcon="content_copy"></mat-icon>{{ 'ERROR_DIALOG.COPY' | transloco
                  }}
                </span>
                <span *ngIf="copyRes" class="fs-16 fw-500 item flex items-center copied-text">
                  <mat-icon class="h-18 w-18 mr-6" svgIcon="check"></mat-icon>{{ 'ERROR_DIALOG.COPIED' | transloco }}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!auditData?.responseBody" class="empty-data flex flex-col items-center mt-32">
        <img class="w-106" alt="response body not found" src="/assets/images/request_body_not_available.png">
        <div class="flex mt-6 ">{{'AUDIT_LIST.NO_RES_BODY' | transloco }}</div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>